<template>
    <div class="rsvp">
        <div class="rsvp_content">
            <img data-v-e44974fa="" src="../../assets/img/template1/rsvp/combined-shape-white-top-01.svg"
                style="justify-self: center; z-index: 1;">
            <div class="form_rsvp">
                <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2FRSVP.svg?alt=media&token=440d436a-1166-481a-9278-04d70ff47d3d" style="justify-self: center; z-index: 1; width: 5rem;" />
                <p>¿Nos Acompañarás?</p>
                <p>Favor confirmar tu asistencia</p>
                <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Fhojitas.svg?alt=media&token=883c9ab9-ff87-4fb9-83e6-07d1b7830e43" style="width: 15rem;">
                <p>R.S.V.P</p>
                <input type="text" v-model="Invitado" placeholder="Nombre" disabled>  
                <select class="selectForm" v-model="num">
                    <option value="" disabled>Número de invitados</option>
                    <option v-for="index in Cantidad" :key="index" :value="index"  >{{ index }}</option>
                </select>
                <select class="selectForm" v-model="message">
                    <option value="" disabled>Transporte de tu preferencia</option>
                    <option value="Su vehículo">Llevo mi vehículo</option>
                    <option value="Transporte de la empresa">Transporte de la empresa</option>
                    <option value="Me iré en otro vehículo">Me iré en otro vehículo</option>
                </select>
                <div style="display: grid; grid-template-columns: repeat(2, 1fr); column-gap: 1rem;">
                    <button style="height: 2rem; margin-bottom: 1rem; background-color: #c3c3c3; color: #1b2a65; width: 8rem;" @click="notAttend()">No asistiré</button>
                    <button style="height: 2rem; margin-bottom: 1rem; background-color: #0076e6; width: 8rem;" @click="create()">Asistiré</button>
                </div>
            </div>
            <img src="../../assets/img/template1/rsvp/combined-shape-white-bottom-01.svg" style="justify-self: center;">
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {

    
    name: 'RSVP',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            email: "",
            message: "",
            phone: "",
            num: "",
            Invitado: this.$route.query.invitado,
            Cantidad: parseInt(this.$route.query.cantidad),
        }
    },
    methods: {
        create() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}rsvp/CreateRSVP/${this.Code}` : `${process.env.VUE_APP_API_PRO}rsvp/CreateRSVP/${this.Code}`;
            let data = {
                name: this.Invitado,
                num: this.num,
                message: this.message
            }
            axios.post(url, data)
                .then((response) => {
                    if (response.status == 200) {
                        Swal.fire(
                            '',
                            'Muchas gracias por confirmar',
                            'success'
                        );
                    }
                    this.name = "";
                    this.email = "";
                    this.num = "";
                    this.message = "";
                    this.phone = "";
                })
                .catch(err => console.error(err));
        },

        notAttend() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}rsvp/NotAttend/${this.Code}` : `${process.env.VUE_APP_API_PRO}rsvp/NotAttend/${this.Code}`;
            let data = {
                name: this.Invitado,
            }
            axios.post(url, data)
                .then((response) => {
                    if (response.status == 200) {
                        Swal.fire(
                            '',
                            'Muchas gracias por confirmar',
                            'success'
                        );
                    }
                    this.name = "";
                    this.email = "";
                    this.num = "";
                    this.message = "";
                    this.phone = "";
                })
                .catch(err => console.error(err));
        }

    },
}
</script>

<style scoped>
.rsvp {
    color: #1b2a65;
}

.rsvp_content {
    width: 30%;
    display: grid;
}

.form_rsvp {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    width: 30rem;
    place-items: center;
    background-color: #fff;
    box-shadow: 12px 0 35px -13px #cdcdcd, -12px 0 35px -13px #cdcdcd;
}

button {
    background-color: rgb(187, 148, 106);
    border-radius: 0.5rem;
}

input[type=text] {
    width: 90%;
}

textarea {
    width: 90%;
}

.selectForm {
    width: 90%;
    color: #6b8181;
}

@media (max-width: 768px) {
    .rsvp_content {
        width: 100% !important;
    }

    .form_rsvp{
        width: 20rem;
    }
}
</style>